import { render } from "./Footer.vue?vue&type=template&id=7f4922ae"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=7f4922ae&lang=css"
script.render = render

export default script